/** A nota do provedor e a nota que o produto mostra são a MESMA escala 0–5 (a
 *  convenção de estrela que Google/Booking instalaram): o Apollo devolve o
 *  `rating` do Google junto de `userRatingCount`, e as faixas de review do
 *  `app-integration` já são 1–5. Existiu aqui uma conversão 0–10 → 0–5 que
 *  dividia por 2 uma nota que já vinha 0–5 — um Ibis 4,2 aparecia como 2,1 e
 *  nenhum hotel passava no filtro "4,0+".
 *
 *  Faixas: ≥4 verde, 3–3,9 âmbar, <3 vermelho. Casa única — consumida pelo badge
 *  do `hotel_rooms` e pelo drawer de detalhes, para as duas superfícies não
 *  divergirem de faixa. */
export function ratingBand(rating: number): 'high' | 'mid' | 'low' {
  if (rating >= 4) return 'high';
  if (rating >= 3) return 'mid';
  return 'low';
}

/** Nota ausente e nota 0 são a mesma coisa no wire: o provedor manda 0 para
 *  hotel sem avaliação, e um selo "★ 0,0 Razoável" inventa uma nota ruim que
 *  ninguém deu. Passa por aqui todo mundo que decide EXIBIR a nota. */
export function ratingOrUndefined(rating: number | undefined): number | undefined {
  return rating === undefined || rating <= 0 ? undefined : rating;
}
